import { parseISO } from 'date-fns'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import { Link } from 'react-router'
import styled from 'styled-components'
import { useAppNotificationActions } from '../hooks'
import type { AppNotificationAction, AppNotificationNode } from '../types'
import { TimeSince } from './TimeSince'
import { getAppNotificationImage } from './util'

const Layout = styled.div<{ $hasVisual: boolean }>`
  display: grid;
  width: 100%;
  grid-template-columns: ${props => (props.$hasVisual ? '1fr 4fr' : '1fr')};
  grid-gap: 1rem;
  align-items: start;
`

const ImageWrapper = styled.div``

const Content = styled.div`
  text-align: left;
  align-self: start;
`

const Text = styled.div`
  font-size: 12px;
  text-align: left;

  p {
    margin-bottom: 0;
  }
`

const TimeSinceWrapper = styled.span`
  font-size: 12px;
  color: ${props => props.theme.colors.gray4};
`

const Actions = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
`

const Action = styled(Link)`
  font-size: 12px;
  cursor: pointer;

  :after:not(:last-of-type) {
    /* Font awesome circle*/
    font-family: 'Font Awesome 6 Pro';
    content: '\\f111';
  }
`

interface AppNotificationItemProps {
  appNotification: AppNotificationNode
  onActionClicked: (action: AppNotificationAction) => void
}

const AppNotificationItem: React.JSX.CFC<AppNotificationItemProps> = ({
  appNotification,
  onActionClicked,
}) => {
  const { getAppNotificationActions } = useAppNotificationActions()

  const actions = getAppNotificationActions(appNotification)
  const notificationImage = getAppNotificationImage(appNotification)

  return (
    <Layout $hasVisual={Boolean(notificationImage)}>
      {notificationImage ? (
        <ImageWrapper>{notificationImage}</ImageWrapper>
      ) : null}
      <Content>
        <Text>
          <ReactMarkdown>{appNotification.message}</ReactMarkdown>
        </Text>

        <TimeSinceWrapper>
          <TimeSince
            timestamp={parseISO(appNotification.createdAt)}
            cutOff={1}
          />
        </TimeSinceWrapper>

        <Actions>
          {actions.map(action => (
            <Action
              key={action.text}
              to={action.link}
              onClick={() => onActionClicked(action)}
            >
              {action.text}
            </Action>
          ))}
        </Actions>
      </Content>
    </Layout>
  )
}

export default AppNotificationItem
